import { Link } from 'react-router-dom';
import styles from './style.module.css'
import icons from '../../icons';
import logo from '../../../img/logo.png';
import { BsDot } from "react-icons/bs";


const MainSection = () => {
    return (
        <div className="content">
            <div className={styles.logo_menu__area}>
                <div className={styles.logo_menu__grid}>
                    <div className={styles.contacts}>
                        <div>
                            <ul>
                                <li><icons.PinIcon /> &nbsp; 107014, г. Москва, ул. Стромынка, д. 10, стр. 1</li>
                                <li><icons.MobileIcon /> &nbsp; 8-916-972-37-76</li>
                                <li><icons.EmailIcon /> &nbsp; mof_2013@mail.ru</li>
                            </ul>
                        </div>
                    </div>
                    <div className={styles.title__area}>
                        <div className={styles.title}>
                            <div className={styles.first_name}>Московское общество фтизиатров</div>
                            <div className={styles.second_name}>Межрегиональная общественная организация</div>
                        </div>
                    </div>
                    <div className={styles.line}><hr /></div>
                    <div className={styles.logo}>
                        <img src={logo} alt="" />
                    </div>
                    <div className={styles.menu}>
                        <div className={styles.row}>
                            <a href='#schools'><div className={styles.item}><BsDot /> Школа московского фтизиатра</div></a>
                        </div>
                        <div className={styles.row}>
                            <a href='#yearly_conference'><div className={styles.item}><BsDot /> Ежегодная конференция Московских фтизиатров</div></a>
                        </div>
                        <div className={styles.row}>
                            <a target='blank' href='http://tb-journal.ru/'><div className={styles.item}><BsDot /> Научно-практический журнал</div></a>
                            <a href="#bulletins"><div className={styles.item + ' ' + styles.ml}><BsDot /> Информационный бюллетень</div></a>
                        </div>
                        <div className={styles.row}>
                            <Link to="/documents"><div className={styles.item}><BsDot /> Документы</div></Link>
                            <Link to="/conferences"><div className={styles.item + ' ' + styles.ml}><BsDot /> Отчеты о конференциях</div></Link>
                        </div>
                        <div className={styles.row}>
                            <Link to='/management/'><div className={styles.item}><BsDot /> Состав Правления</div></Link>
                            <Link to="/news"><div className={styles.item + ' ' + styles.ml}><BsDot /> Новости</div></Link>

                        </div>
                        <div className={styles.row}>
                            <a href="#contacts"><div className={styles.item}><BsDot /> Контактная информация</div></a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default MainSection;